/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_Footer_BadgesInputs */

const en_admin_nav_footer_badges = /** @type {(inputs: Admin_Nav_Footer_BadgesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footer badges`)
};

/**
* | output |
* | --- |
* | "Footer badges" |
*
* @param {Admin_Nav_Footer_BadgesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_nav_footer_badges = /** @type {((inputs?: Admin_Nav_Footer_BadgesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_Footer_BadgesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_nav_footer_badges(inputs)
});
export { admin_nav_footer_badges as "admin.nav.footer_badges" }